// extracted by mini-css-extract-plugin
module.exports = {"desc":"Competencies-module__desc___2kKuS"};